import React, { useMemo } from 'react';
import { Icon, IconsEnum } from 'components/Icons';

import { FieldProps } from 'components/mieScommesseTableRow/MieScommesseTableRow';
import { breakpoint } from 'utility/constant';
import styles from './mieScommesseEvent.module.scss';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export const MieScommesseEvent = (props: FieldProps) => {
  const { label, event, isInColumn, noMargin } = props;

  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.sm }]);

  const numberEvents = useMemo(() => {
    const number = event!.win + event!.live + event!.programmed + event!.lose;
    if (isNaN(number)) return 0;
    return number;
  }, [event]);

  return (
    <div
      className={`${styles.eventContainer} ${isInColumn ? styles.eventInColumn : ''} ${
        noMargin && (isMobile || isInColumn) ? styles.noMarginBottom : ''
      }`}
    >
      {/* <p className={styles.betLabel}>{numberEvents + ' ' + label}</p> */}
      {numberEvents !== 0 && !noMargin && <p className={styles.betLabel}>{numberEvents + ' ' + label}</p>}
      <div className={styles.flex}>
        {event?.win === 0 || event?.win === undefined ? null : (
          <React.Fragment>
            <Icon iconId={IconsEnum.SUCCESS} color="var(--color-success)" className={styles.icon} />
            <span className={styles.eventNumber}>{event?.win}</span>
          </React.Fragment>
        )}
        {event?.live === 0 || event?.live === undefined ? null : (
          <React.Fragment>
            <Icon iconId={IconsEnum.MATCH_LIVE} className={styles.icon} color="var(--color-accent)" />
            <span className={styles.eventNumber}>{event?.live}</span>
          </React.Fragment>
        )}
        {event?.programmed === 0 || event?.programmed === undefined ? null : (
          <React.Fragment>
            <Icon iconId={IconsEnum.PROGRAMMED} className={styles.icon} color=" #62C5DB" />
            <span className={styles.eventNumber}>{event?.programmed}</span>
          </React.Fragment>
        )}
        {event?.lose === 0 || event?.lose === undefined ? null : (
          <React.Fragment>
            <Icon iconId={IconsEnum.EXCLAMATION_CIRCLE} color="var(--color-warning)" className={styles.icon} />
            <span className={styles.eventNumber}>{event?.lose}</span>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};